var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import authentication from "@irati/auth";
import defaultAuth from "@irati/auth/helpers/defaultAuth";
import companyBenefitsService from "@irati/deals/services/companyBenefits";
import { getBlacklistedDeals, getBlacklistedTags, updateBlacklistedDeals, updateBlacklistedTags } from "@irati/permissions/services/packages";
import { query as ValueListQuery } from "@irati/companyvalues/apollo/query/CompanyValuesList";
import { mutation as ArchiveValueMutation } from "@irati/companyvalues/apollo/mutation/Archive";
import client from "@irati/utils/services/apollo";
import { TenantOnboardingStepStates, TeamState } from "@irati/types";
import { store } from "@irati/store";
import AuthActions from "@irati/auth/store/actions/AuthActions";
import teamService from "@irati/identity/services/teams";
import brandingService from "@irati/brand/services/branding";
import BrandingStream from "@irati/brand/streams/branding";
import { SSO_TYPE_SAML } from "@irati/sso/constants/signUpOptions";
import { deleteSaml } from "@irati/sso/services/sso";
import stepDetails, { sectionMapping, SetupSteps } from "../constants/stepConfig";
export var isPathActive = function (path) { return location.pathname.includes(path); };
export var getStepDetails = function (step) {
    return stepDetails[step.stepId] || {};
};
export var isValidStep = function (step) {
    if (Object.keys(stepDetails).includes(step.stepId)) {
        if (stepDetails[step.stepId].hideStep) {
            return !stepDetails[step.stepId].hideStep();
        }
        return true;
    }
};
export var generateReadableStepNumber = function (stepNumber) { return (stepNumber >= 10 ? "" + stepNumber : "0" + stepNumber); };
export var orderSteps = function (steps) {
    return steps.sort(function (stepA, stepB) { return getStepDetails(stepA).order - getStepDetails(stepB).order; });
};
export var getFirstIncompleteStep = function (steps) {
    var firstUncompleteStep = orderSteps(steps).find(function (step) {
        var stepInfo = getStepDetails(step);
        return step.state !== TenantOnboardingStepStates.Done && (!stepInfo.hideStep || !stepInfo.hideStep());
    });
    return firstUncompleteStep || steps[steps.length - 1];
};
export var areAllStepsDone = function (steps) { return !steps.some(function (step) { return step.state !== TenantOnboardingStepStates.Done; }); };
var getNextStep = function (currentStepId, steps) {
    var orderedSteps = orderSteps(steps);
    var currentIndex = orderedSteps.findIndex(function (step) { return step.stepId === currentStepId; });
    if (currentIndex === orderedSteps.length)
        return orderedSteps[orderedSteps.length - 1];
    var nextValidStep = orderedSteps.find(function (step, index) {
        var stepInfo = getStepDetails(step);
        return (!stepInfo.hideStep || !stepInfo.hideStep()) && index > currentIndex;
    });
    return nextValidStep || orderedSteps[orderedSteps.length - 1];
};
export var getNextStepPath = function (currentStepId, steps) {
    return getStepDetails(getNextStep(currentStepId, steps)).nestedPath;
};
export var getOrderedSectionSteps = function (steps, section) {
    return orderSteps(steps).filter(function (step) { return sectionMapping[section].includes(step.stepId); });
};
export var isDefaultBrand = function () {
    return new Promise(function (resolve) {
        var _a = BrandingStream.get(), businessLogoUrl = _a.businessLogoUrl, primaryColour = _a.primaryColour;
        var _b = defaultAuth.userTenant.settings, defaultImageLink = _b.imageLink, defaultColor = _b.color;
        resolve(businessLogoUrl === defaultImageLink && primaryColour === defaultColor);
    });
};
export var resetBrand = function () {
    var tenant = authentication.userTenant();
    var _a = defaultAuth.userTenant.settings, businessLogoUrl = _a.imageLink, primaryColour = _a.color;
    var data = {
        businessId: tenant.uuid,
        teamId: tenant.rootTeamId,
        businessLogoUrl: businessLogoUrl,
        primaryColour: primaryColour
    };
    return brandingService.update(data);
};
var benefitQueryOptions = {
    limit: 1000
};
export var isDefaultBenefits = function () {
    return companyBenefitsService.list(benefitQueryOptions).then(function (res) { return res.total === 0; });
};
export var resetBenefits = function () {
    return companyBenefitsService.list(benefitQueryOptions).then(function (res) {
        var allArchivePromises = res.data.map(function (benefit) { return companyBenefitsService.archive(benefit.uuid); });
        return Promise.all(allArchivePromises);
    });
};
export var isDefaultPerksVisibility = function () { return __awaiter(void 0, void 0, void 0, function () {
    var tenant, results, blacklistedTags, blacklistedDeals;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                tenant = authentication.userTenant();
                return [4 /*yield*/, Promise.all([getBlacklistedTags({ tenant: tenant }), getBlacklistedDeals({ tenant: tenant })])];
            case 1:
                results = _a.sent();
                blacklistedTags = results[0];
                blacklistedDeals = results[1];
                return [2 /*return*/, !blacklistedTags.length && !blacklistedDeals.length];
        }
    });
}); };
export var resetPerksVisibility = function () {
    var tenant = authentication.userTenant();
    return Promise.all([updateBlacklistedTags({ tenant: tenant }, []), updateBlacklistedDeals({ tenant: tenant }, [])]);
};
export var isDefaultWelcomeEmail = function () {
    return new Promise(function (resolve) {
        var tenant = authentication.userTenant();
        resolve(tenant.settings.welcomeEmail === null);
    });
};
export var resetWelcomeEmail = function () {
    var tenant = authentication.userTenant();
    var data = {
        businessId: tenant.uuid,
        teamId: tenant.rootTeamId,
        welcomeEmail: ""
    };
    return brandingService.update(data).then(function () {
        return store.dispatch(AuthActions.updateTenant(tenant));
    });
};
export var isReadyToInvite = function (steps) {
    return steps.every(function (step) { return step.state === TenantOnboardingStepStates.Done || step.stepId === SetupSteps.INVITE; });
};
export var isDefaultTeams = function () {
    var tenant = authentication.userTenant();
    // do we have 0 teams?
    return teamService.list(tenant.uuid, { state: TeamState.Ok, userTotalOnly: true }).then(function (teams) { return !teams.length; });
};
export var resetTeams = function () {
    var tenant = authentication.userTenant();
    return teamService.list(tenant.uuid, { state: TeamState.Ok, userTotalOnly: true }).then(function (teams) {
        return Promise.all(teams.map(function (team) {
            return teamService.delete(tenant.uuid, team.uuid);
        }));
    });
};
var getValues = function () {
    var tenant = authentication.userTenant();
    var variables = {
        tenantId: tenant.uuid,
        limit: 100
    };
    return client.query({ query: ValueListQuery, variables: variables, fetchPolicy: "network-only" }).then(function (_a) {
        var data = _a.data;
        return data.companyValues;
    });
};
export var isDefaultValues = function () { return getValues().then(function (_a) {
    var count = _a.count;
    return count === 0;
}); };
export var resetValues = function () {
    var tenant = authentication.userTenant();
    var archivePromises = [];
    return getValues()
        .then(function (_a) {
        var results = _a.results;
        results.map(function (companyValue) {
            var variables = {
                tenantId: tenant.uuid,
                companyValue: companyValue
            };
            archivePromises.push(client.mutate({ mutation: ArchiveValueMutation, variables: variables }));
        });
    })
        .then(function () { return Promise.all(archivePromises); })
        .then(getValues);
};
export var isDefaultSSO = function (isSSOStep) {
    var tenant = authentication.userTenant();
    return new Promise(function (resolve) {
        resolve(!isSSOStep || tenant.settings.signUpOption !== SSO_TYPE_SAML);
    });
};
export var resetSSO = function () {
    return deleteSaml();
};
export var getCurrentTenantSetupStepConfig = function () {
    var urlArray = window.location.pathname.split("/");
    var path = urlArray[urlArray.length - 1];
    var currentStepConfig = null;
    Object.keys(stepDetails).map(function (stepId) {
        if (stepDetails[stepId].nestedPath === "/" + path) {
            currentStepConfig = __assign(__assign({}, stepDetails[stepId]), { stepId: stepId });
        }
    });
    return currentStepConfig;
};
